import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'
import { initAnalyticsClient } from './analytics/client.ts'

if (ENV.MODE === 'production' && ENV.SENTRY_DSN) {
	void import('./utils/monitoring.client.tsx').then(({ init }) => init())
}

/*
 * PostHog is initialised here, before hydration, rather than in root's effect.
 *
 * `<PostHogClient />` renders *after* `<Outlet />` in root, and React runs
 * effects in mount order — so every route effect ran before PostHog was
 * initialised. The listing beacons (`useBusinessProfileView`, contact-link
 * clicks) therefore fired before the `ph_..._posthog` cookie existed, and
 * `getPosthogDistinctId` returned undefined for them. `trackServer` drops any
 * event with no distinct id *silently*, so the first-party DB counter
 * incremented while the PostHog event vanished: 8 profile views in
 * `BusinessMetricDay` against 1 in PostHog over 30 days.
 *
 * Initialising before `hydrateRoot` means the cookie is written before any
 * component effect can run. `initAnalyticsClient` is idempotent, so root's
 * call becomes a no-op and still covers any non-hydrated entry path.
 */
initAnalyticsClient()

startTransition(() => {
	hydrateRoot(document, <HydratedRouter />)
})
